/* TAFKA START — Shipping Progress Bar (multi-tier, portable behaviour)
   Global script. Reads per-instance config from data-* attributes on every
   [data-spb-container] and live-updates them whenever the cart changes.

   Minimalista integration:
   - subscribes to the global 'cart-update' PubSub event (published by
     product-form.js on add-to-cart and cart.js on drawer quantity change)
   - the bar containers (PDP block + drawer header) persist across the cart
     drawer's Section-Rendering-API re-renders, so we just re-render in place. */
(function () {
  'use strict';

  function parseTiers(c) {
    var tiers = [];
    for (var i = 1; i <= 3; i++) {
      var th = parseFloat(c.dataset['spbTier' + i + 'Threshold']);
      var rw = c.dataset['spbTier' + i + 'Reward'] || '';
      if (th > 0) tiers.push({ threshold: th, reward: rw, idx: i });
    }
    tiers.sort(function (a, b) { return a.threshold - b.threshold; });
    return tiers;
  }

  function configFor(c) {
    var tiers = parseTiers(c);
    var max = parseFloat(c.dataset.spbTarget) ||
      (tiers.length ? tiers[tiers.length - 1].threshold : 0);
    return {
      multi: c.dataset.spbMultiTier === 'true',
      target: max,
      trackBy: c.dataset.spbTrackBy || 'weight',
      unit: c.dataset.spbUnit || '',
      msgProgress: c.dataset.spbMsgProgress || 'Add [remaining] more for free shipping!',
      msgProgressMulti: c.dataset.spbMsgProgressMulti || 'Noch [remaining] für [reward]!',
      msgComplete: c.dataset.spbMsgComplete || 'Free shipping unlocked!',
      msgAllComplete: c.dataset.spbMsgAllComplete || 'Alle Belohnungen freigeschaltet!',
      successColor: c.dataset.spbSuccessColor || '#16a34a',
      barColor: c.dataset.spbBarColor || '#22c55e',
      tiers: tiers
    };
  }

  function computeCurrent(cfg, cart) {
    if (cfg.trackBy === 'weight') return cart.total_weight / 1000;
    if (cfg.trackBy === 'price') return cart.total_price / 100;
    return cart.item_count;
  }

  function tierByIdx(cfg, idx) {
    for (var k = 0; k < cfg.tiers.length; k++) {
      if (cfg.tiers[k].idx === idx) return cfg.tiers[k];
    }
    return null;
  }

  function renderBar(c, current) {
    var cfg = configFor(c);
    if (!cfg.tiers.length || !cfg.target) return;
    if (typeof current !== 'number' || isNaN(current)) current = 0;

    var fillEl = c.querySelector('[data-spb-fill]');
    var messageEl = c.querySelector('[data-spb-message]');

    var pct = Math.min((current / cfg.target) * 100, 100);
    if (fillEl) fillEl.style.width = pct + '%';

    var reached = 0;
    var next = null;
    for (var i = 0; i < cfg.tiers.length; i++) {
      if (current >= cfg.tiers[i].threshold) reached++;
      else if (next === null) next = cfg.tiers[i];
    }
    var all = reached === cfg.tiers.length;
    if (all) next = cfg.tiers[cfg.tiers.length - 1];

    if (fillEl) fillEl.style.background = all ? cfg.successColor : cfg.barColor;

    if (cfg.multi) {
      c.querySelectorAll('[data-spb-milestone]').forEach(function (el) {
        var t = tierByIdx(cfg, parseInt(el.dataset.spbMilestone, 10));
        if (t) el.classList.toggle('spb-portable__milestone--reached', current >= t.threshold);
      });
      c.querySelectorAll('[data-spb-legend]').forEach(function (el) {
        var t = tierByIdx(cfg, parseInt(el.dataset.spbLegend, 10));
        if (t) el.classList.toggle('spb-portable__legend-item--reached', current >= t.threshold);
      });
    }

    if (messageEl) {
      if (all) {
        messageEl.textContent = cfg.multi ? cfg.msgAllComplete : cfg.msgComplete;
      } else {
        var ref = cfg.multi ? next : cfg.tiers[0];
        var remaining = Math.max(ref.threshold - current, 0);
        var rStr = remaining % 1 === 0 ? remaining.toString() : remaining.toFixed(1);
        var rUnit = cfg.unit ? rStr + ' ' + cfg.unit : rStr;
        var tpl = cfg.multi ? cfg.msgProgressMulti : cfg.msgProgress;
        messageEl.textContent = tpl.replace('[remaining]', rUnit).replace('[reward]', ref.reward);
      }
    }
  }

  var inFlight = false;
  function refreshAll() {
    var bars = document.querySelectorAll('[data-spb-container]');
    if (!bars.length || inFlight) return;
    inFlight = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-spb-container]').forEach(function (el) {
          renderBar(el, computeCurrent(configFor(el), cart));
        });
      })
      .catch(function (e) { console.error('[spb] cart fetch failed', e); })
      .finally(function () { inFlight = false; });
  }

  // Minimalista PubSub — covers add-to-cart and drawer quantity changes.
  if (typeof subscribe === 'function') {
    try { subscribe('cart-update', refreshAll); } catch (e) { /* noop */ }
  }
  // Generic fallbacks for other themes / cart apps that dispatch DOM events.
  ['cart:updated', 'cart:change', 'cart:refresh', 'variant:add'].forEach(function (evt) {
    document.addEventListener(evt, refreshAll);
  });

  function boot() {
    if (document.querySelector('[data-spb-container]')) refreshAll();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Late safety pass for containers revealed after first paint (e.g. drawer).
  setTimeout(boot, 800);
})();
/* TAFKA END — Shipping Progress Bar */
